import { Modal } from "bootstrap";
import { useEffect, useRef } from "react";
import ReactDOM from "react-dom";

const portalElement: any = document.getElementById("overlays");

const ModalWindow: React.FC<{
  title: string;
  isLarge?: boolean;
  isShowOk?: boolean;
  isOkEnabled?: boolean;
  hasCancel?: boolean;
  okButtonTitle?: string | undefined;
  onOk: any;
  onCancel?: any;
  children: any;
}> = ({
  title,
  isLarge = false,
  isShowOk = true,
  isOkEnabled = true,
  hasCancel = true,
  okButtonTitle = undefined,
  onOk,
  onCancel,
  children,
}) => {
  const modalRef = useRef<any>();

  const showModal = () => {
    const modalElement = modalRef.current;

    let modal = Modal.getInstance(modalElement);
    if (!modal) {
      modal = new Modal(modalElement, {
        backdrop: "static",
        keyboard: false,
      });
    }

    modal.show();
  };

  const hideModal = () => {
    const modalElement = modalRef.current;
    const modal = Modal.getInstance(modalElement);
    modal?.hide();
  };

  const cancelHandler = (e: any) => {
    e.stopPropagation();

    hideModal();
    if (onCancel) {
      onCancel();
    }
  };

  const okHandler = async (e: any) => {
    e.stopPropagation();

    const modalElement = modalRef.current;
    const modal = Modal.getInstance(modalElement);

    let onOkResult = onOk();

    if (onOkResult instanceof Promise) {
      onOkResult = await onOkResult;
    }

    if (onOkResult !== false) {
      modal?.hide();
    }
  };

  useEffect(() => {
    showModal();
  }, []);

  return (
    <>
      {ReactDOM.createPortal(
        <div className="modal fade" ref={modalRef} tabIndex={-1}>
          <div className={"modal-dialog " + (isLarge ? "modal-lg" : "")}>
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{title}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={cancelHandler}
                  aria-label="Close"
                ></button>
              </div>
              <div className="modal-body">{children}</div>
              <div className="modal-footer">
                {hasCancel && (
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={cancelHandler}
                  >
                    Cancel
                  </button>
                )}
                {isShowOk && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    disabled={!isOkEnabled}
                    onClick={okHandler}
                  >
                    {okButtonTitle ? okButtonTitle : "Ok"}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>,
        portalElement,
      )}
    </>
  );
};

export default ModalWindow;
